import { InjectionToken } from '@angular/core';
import { CommonConfig } from '../models/common-config/common-config.interface';

export const COMMON_CONFIG = new InjectionToken<CommonConfig>('Common config');
